import * as React from 'react';
import { Outlet, Route, RouterProvider, createBrowserRouter, createRoutesFromElements, Navigate } from 'react-router-dom';
import StafficeAuthProvider from '../components/AuthProvider/StafficeAuthProvider';
import Circle from '../components/Loader/Circle';
const Login = React.lazy(() => import('./Login'));
const AppState = React.lazy(() => import('../app'));
const LoginSucess = React.lazy(() => import('./LoginSuccess'));
const FirstLogin = React.lazy(() => import('./FirstLogin'));
const AppLayout = React.lazy(() => import('../layouts/AppLayout'));
const DevInfo = React.lazy(() => import('../components/DevInfo'));
const RouteLoader = React.createElement("div", { className: "flex items-center justify-center w-full h-full" },
    React.createElement(Circle, null));
const Router = () => {
    const routes = createBrowserRouter(createRoutesFromElements(React.createElement(React.Fragment, null,
        React.createElement(Route, { path: "/", element: React.createElement(StafficeAuthProvider, null,
                React.createElement(React.Suspense, { fallback: RouteLoader },
                    React.createElement(Outlet, null))) },
            React.createElement(Route, { path: "/chat", element: React.createElement(AppState, null) })),
        React.createElement(Route, { path: "login", element: React.createElement(React.Suspense, { fallback: RouteLoader },
                React.createElement(Login, null)) }),
        React.createElement(Route, { path: "login-success", element: React.createElement(React.Suspense, { fallback: RouteLoader },
                React.createElement(LoginSucess, null)) }),
        process.env.FEATURE_FIRSTLOGIN && (React.createElement(Route, { path: "first-login", element: React.createElement(React.Suspense, { fallback: RouteLoader },
                React.createElement(AppLayout, null,
                    React.createElement(FirstLogin, null))) })),
        process.env.TARGET === 'dev' && (React.createElement(Route, { path: "dev-info", element: React.createElement(React.Suspense, { fallback: RouteLoader },
                React.createElement(DevInfo, null)) })),
        React.createElement(Route, { path: "*", element: React.createElement(Navigate, { to: "/chat", replace: true }) }))));
    return React.createElement(RouterProvider, { router: routes });
};
export default Router;
